import { Injectable, OnDestroy } from '@angular/core';
import { guid, Store } from '@datorama/akita';
import { DataTestRunnerState } from './data-test.model';

export function createInitialState(): DataTestRunnerState {
  return {
    runTest: {
      loading: false,
      response: null,
      httpErrorOccurred: false,
    },
    rerunTestSuite: {
      loading: false,
      httpErrorOccurred: false,
    },
  };
}

@Injectable()
export class DataTestRunnerStore extends Store<DataTestRunnerState> implements OnDestroy {
  constructor() {
    super(createInitialState(), { name: `data-test-runner-${guid()}`, resettable: false });
  }

  ngOnDestroy(): void {
    this.destroy();
  }
}
